import React from 'react'

const ChartPieAlt = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.25 5.78835C7.59833 6.16364 4.75 9.2492 4.75 13C4.75 17.0041 7.99594 20.25 12 20.25C15.7508 20.25 18.8364 17.4017 19.2117 13.75H12C11.5858 13.75 11.25 13.4142 11.25 13V5.78835ZM3.25 13C3.25 8.16753 7.16751 4.25002 12 4.25002C12.4142 4.25002 12.75 4.58581 12.75 5.00002V12.25H20C20.4142 12.25 20.75 12.5858 20.75 13C20.75 17.8325 16.8325 21.75 12 21.75C7.16751 21.75 3.25 17.8325 3.25 13Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M15.5 4.67367V9.50002H20.3264C19.7633 7.11562 17.8844 5.2367 15.5 4.67367ZM14.998 3.06167C18.6183 3.5122 21.4878 6.38169 21.9384 10.002C22.0066 10.5501 21.5523 11 21 11H14.5C14.2239 11 14 10.7762 14 10.5V4.00002C14 3.44774 14.45 2.99347 14.998 3.06167Z" />
    </svg>


)


export default ChartPieAlt
